<button class="btnmr approve-modal-btn bg-theme  mr-auto" (click)="showmagnify()">
    <img class="imgwidth" src="assets/images/magnifying-glass.png">
    Magnify
</button>  
